const { formatText } = require('core/i18n').i18n;

const text = () => {
    return {
        LABEL: {
            ACCEPT: formatText('common-accept'),
            EXTRA_AMOUNT: formatText('mortgageRequestMovingExpenses-mortgageRequestMovingExpenses_extraAmount'),
            BACK: formatText('common-back'),
            SAVE: formatText('common-save'),
        }
    }
}

module.exports = {
    text
};
